const SET = (state, dataset) => {
  state.dataset = dataset
}

const SET_DATASETS = (state, payload) => {
  state.tree = payload.tree
  state.datasets = payload.grid
}

const SET_LOADING = (state, status) => {
  state.loading = status
}

const UNSET = (state) => {
  state.dataset = null
}

const PUSH = (state, dataset) => {
  const exists = state.datasets.findIndex(x => x.id === dataset.id) !== -1

  if (!exists) {
    state.datasets.push(dataset)
  }
}

const PURGE = (state) => {
  state.datasets = []
}

const UPDATE = (state, dataset) => {
  const idx = state.datasets.findIndex(x => x.id === dataset.id)

  if (idx !== -1) {
    state.datasets.splice(idx, 1, dataset)
  }
}

const REMOVE = (state, datasetId) => {
  const idx = state.datasets.findIndex(x => x.id === datasetId)

  if (idx !== -1) {
    state.datasets.splice(idx, 1)
  }
}

const PUSH_BULK_DATASETS = (state, data) => {
  data.forEach((dataset) => {
    if (state.datasets.findIndex(x => x.id === dataset.id) === -1) {
      state.datasets.push(dataset)
    }
  })
}

const UPDATE_DATASET = (state, data) => {
  const dataset = state.datasets.find(x => x.id === data.id)

  if (dataset) {
    dataset.column_values = data.column_values
    dataset.valuesPerColumn = data.valuesPerColumn
  }
}

const REMOVE_DATASET = (state, datasetId) => {
  const idx = state.datasets.findIndex(x => x.id === parseInt(datasetId))

  if (idx !== -1) {
    state.datasets.splice(idx, 1)
  }
}

const RESTORE_DATASET = (state, datasetId) => {
  const trashColumns = [99990, 99991]
  const dataset = state.datasets.find(x => x.id === datasetId)

  if (dataset) {
    dataset.user = dataset.deleted_at = null

    trashColumns.forEach(trashColumn => {
      const idx = dataset.column_values.findIndex(x => x.column_id === trashColumn)

      if (idx !== -1) {
        dataset.column_values.splice(idx, 1)
      }
    })
  }
}

const TOGGLE_WITH_TRASHED = (state) => {
  state.withTrashed = !state.withTrashed
}

const SET_IMPORT = (state, datasets) => {
  state.importables = datasets
}

const CLEAR_IMPORT = (state) => {
  state.importables = null
}

const SET_REFRESHING = (state, payload) => {
  state.refreshing = payload
}

export default {
  SET,
  PUSH,
  UNSET,
  PURGE,
  UPDATE,
  REMOVE,
  SET_IMPORT,
  SET_LOADING,
  CLEAR_IMPORT,
  SET_DATASETS,
  UPDATE_DATASET,
  REMOVE_DATASET,
  SET_REFRESHING,
  RESTORE_DATASET,
  PUSH_BULK_DATASETS,
  TOGGLE_WITH_TRASHED
}
